(function ($) {
	var increaseFontsize = function () {
		if ($('body').hasClass('font-small')) {
			$('body').removeClass('font-small');
		}
		$('body').addClass('font-large');
	};
	var decreaseFontsize = function () {
		if ($('body').hasClass('font-large')) {
			$('body').removeClass('font-large');
		}
		$('body').addClass('font-small');
	};
	var normaliseFontsize = function () {
		if ($('body').hasClass('font-large')) {
			$('body').removeClass('font-large');
		}
		if ($('body').hasClass('font-small')) {
			$('body').removeClass('font-small');
		}
	};
	$(document).ready(
		$('.accessibility a:first-child').click(decreaseFontsize),
		$('.accessibility a:nth-child(2)').click(normaliseFontsize),
		$('.accessibility a:last-child').click(increaseFontsize)
	);
})(jQuery);
